import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/share.png'


const _withScopeId = n => (_pushScopeId("data-v-2fe8684b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-info" }
const _hoisted_2 = {
  key: 0,
  class: "contents"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/video" }, "视频专区", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "视频详情", -1))
const _hoisted_8 = { class: "contents-info" }
const _hoisted_9 = { class: "info-left" }
const _hoisted_10 = { class: "video-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "attr-p-span" }, "相关分类:", -1))
const _hoisted_12 = { class: "attr-p" }
const _hoisted_13 = { class: "edit-span" }
const _hoisted_14 = {
  key: 0,
  class: "icon iconfont icon-shoucang2"
}
const _hoisted_15 = {
  key: 1,
  class: "icon iconfont icon-shoucang1"
}
const _hoisted_16 = { class: "edit-span-share" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-span-share-info" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode("分享")
], -1))
const _hoisted_18 = { class: "share-list" }
const _hoisted_19 = { class: "goods-lable" }
const _hoisted_20 = { class: "info-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_vue3VideoPlay = _resolveComponent("vue3VideoPlay")!
  const _component_share = _resolveComponent("share")!
  const _component_video_info_goods = _resolveComponent("video-info-goods")!
  const _component_video_info_good_list = _resolveComponent("video-info-good-list")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    (_ctx.goodsInfo.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goodsInfo.data.names), 1),
            _createVNode(_component_current_address, null, {
              address: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(">"),
                _hoisted_6,
                _createTextVNode(" > "),
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createBlock(_component_vue3VideoPlay, _mergeProps({
                  key: _ctx.options.src
                }, _ctx.options), null, 16))
              ]),
              _createElementVNode("p", null, [
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsInfo.data.attr, (attr, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "attr-span",
                      key: index
                    }, _toDisplayString(attr), 1))
                  }), 128))
                ]),
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{ active: _ctx.goodsInfo.data.store == 1 }, "edit-span-shoucang"]),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addStart && _ctx.addStart(...args)))
                  }, [
                    (_ctx.goodsInfo.data.store != 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true),
                    (_ctx.goodsInfo.data.store == 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                      : _createCommentVNode("", true),
                    _createTextVNode(" 收藏")
                  ], 2),
                  _createElementVNode("span", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_share, {
                        url: _ctx.routerPath,
                        douban: true,
                        title: _ctx.goodsInfo.data.names,
                        description: _ctx.goodsInfo.data.content
                      }, null, 8, ["url", "title", "description"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_19, "简介：" + _toDisplayString(_ctx.goodsInfo.data.content), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(), _createBlock(_component_video_info_goods, {
                key: _ctx.goodsInfo.data.id,
                goods: _ctx.goodsInfo.data
              }, null, 8, ["goods"])),
              _createVNode(_component_video_info_good_list, {
                cid: _ctx.scid,
                aid: _ctx.aid,
                sort: _ctx.sort,
                curIndex: (_ctx.goodsInfo.curIndex as number),
                nowid: _ctx.goodsInfo.data.id,
                onSedGoodsInfo: _ctx.sedGoodsInfo
              }, null, 8, ["cid", "aid", "sort", "curIndex", "nowid", "onSedGoodsInfo"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_html_footer)
  ]))
}